import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Catalog } from '../../../models/catalog/catalog';
import { CatalogItem } from '../../../models/catalog/catalogItem';
import { CatalogService } from '../../../models/catalog/catalogService';
import { InvoiceItem } from '../../../models/invoices/invoiceItem';
import { TextModes } from '../../ui/controls/text-input/text-input.component';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-invoice-select-items',
  standalone: false,
  templateUrl: './invoice-select-items.component.html',
})
export class InvoiceSelectItemsComponent {
  selectedTabTitle: string = '';
  catalogId: string | undefined;
  catalogName: string | undefined;
  catalogOptions: ListItem[] = [];
  saveToCatalog: boolean = false;
  discountOrCredit: boolean = false;

  newCatalogName: string | undefined;
  newCatalogDescription: string | undefined;

  customCatalogItem: Partial<CatalogItem> = CatalogItem.createEmpty();
  customCatalogItemQuantity: number = 1;
  TextModes = TextModes;

  constructor(
    public dialogRef: MatDialogRef<InvoiceSelectItemsComponent>,
    public loadingSpinnerDialog: MatDialog,
    public catalogService: CatalogService,
    public uiErrorHandler: UIErrorHandler,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      //catalogId: string,
      merchantId: string;
    },
  ) {
    this.selectedTabTitle = 'Add New Item';
    this.catalogService
      .getCatalogs(data.merchantId)
      .then((catalogs: Partial<Catalog>[]) => {
        this.catalogOptions = this.catalogOptions.concat(
          catalogs.map(
            (catalog: Partial<Catalog>) =>
              new ListItem({ id: catalog.id, name: catalog.name }),
          ),
        );

        if (this.catalogOptions.length == 2) {
          this.catalogId = this.catalogOptions[1].id;
        }
      });
  }

  handleCatalogNameChanged(event: any) {
    this.catalogName = this.catalogOptions.find(
      (option: ListItem) => option.id == this.catalogId,
    )?.name;
  }

  handleAddItemClicked() {
    if (
      this.customCatalogItem.name == null ||
      this.customCatalogItem.name == ''
    ) {
      this.uiErrorHandler.handleError('Item name is required');
      return;
    }
    if (
      this.customCatalogItem.price == null ||
      this.customCatalogItem.price == 0
    ) {
      this.uiErrorHandler.handleError('Item price is required');
      return;
    }
    if (
      this.customCatalogItemQuantity == null ||
      this.customCatalogItemQuantity == 0
    ) {
      this.uiErrorHandler.handleError('Item quantity is required');
      return;
    }

    this.customCatalogItem.currencyCode = 'USD';
    this.customCatalogItem.catalogId = this.catalogId;

    if (this.selectedTabTitle === 'Discount or Credit') {
      this.customCatalogItem.price = -(this.customCatalogItem.price || 0);
      this.customCatalogItemQuantity = 1;
    }

    if (this.saveToCatalog) {
      this.catalogService
        .createCatalogItem(this.customCatalogItem)
        .then((item: Partial<CatalogItem>) => {
          let invoiceItem = this.getInvoiceItemFromCustomCatalogItem();
          invoiceItem.catalogItemId = item.id ? item.id : '';

          this.dialogRef.close({
            item: invoiceItem,
            quantity: this.customCatalogItemQuantity,
          });
        });
    } else {
      this.dialogRef.close({
        item: this.getInvoiceItemFromCustomCatalogItem(),
        quantity: this.customCatalogItemQuantity,
      });
    }
  }

  handleCancelClicked() {
    this.dialogRef.close();
  }

  getInvoiceItemFromCustomCatalogItem(): InvoiceItem {
    return new InvoiceItem({
      catalogItemId: this.customCatalogItem.id,
      name: this.customCatalogItem.name,
      description: this.customCatalogItem.description,
      unitPrice: this.customCatalogItem.price || 0,
      quantity: this.customCatalogItemQuantity,
      total:
        (this.customCatalogItem.price || 0) * this.customCatalogItemQuantity,
    });
  }
}
